const langs = [
  {'code': 'en', 'name': 'English (American)'},
  {'code': 'ar-dz', 'name': 'Arabic (Algeria)'},
  {'code': 'ar-kw', 'name': 'Arabic (Kuwait)'},
  {'code': 'ar-ly', 'name': 'Arabic (Libya)'},
  {'code': 'ar-ma', 'name': 'Arabic (Morocco)'},
  {'code': 'ar-sa', 'name': 'Arabic (Saudi Arabia)'},
  {'code': 'ar-tn', 'name': 'Arabic (Tunisia)'},
  {'code': 'ar', 'name': 'Arabic', 'nativeName': 'العربية'},
  {'code': 'bg', 'name': 'Bulgarian', 'nativeName': 'български език'},
  {'code': 'ca', 'name': 'Catalan; Valencian', 'nativeName': 'Català'},
  {'code': 'cs', 'name': 'Czech', 'nativeName': 'česky, čeština'},
  {'code': 'da', 'name': 'Danish', 'nativeName': 'dansk'},
  {'code': 'de-at', 'name': 'German (Austria)', 'nativeName': 'Deutsch (Österreich)'},
  {'code': 'de-ch', 'name': 'German (Switzerland)', 'nativeName': 'Deutsch (Schweiz)'},
  {'code': 'de', 'name': 'German', 'nativeName': 'Deutsch'},
  {'code': 'el', 'name': 'Greek, Modern', 'nativeName': 'Ελληνικά'},
  {'code': 'en-au', 'name': 'English (Australia)'},
  {'code': 'en-ca', 'name': 'English (Canada)'},
  {'code': 'en-gb', 'name': 'English (United Kingdom)'},
  {'code': 'en-ie', 'name': 'English (Ireland)'},
  {'code': 'en-nz', 'name': 'English (New Zealand)'},
  {'code': 'es-do', 'name': 'Spanish (Dominican Republic)'},
  {'code': 'es-us', 'name': 'Spanish (American)'},
  {'code': 'es', 'name': 'Spanish; Castilian', 'nativeName': 'español, castellano'},
  {'code': 'et', 'name': 'Estonian', 'nativeName': 'eesti, eesti keel'},
  {'code': 'fa', 'name': 'Persian', 'nativeName': 'فارسی'},
  {'code': 'fi', 'name': 'Finnish', 'nativeName': 'suomi, suomen kieli'},
  {'code': 'fr-ca', 'name': 'French (Canadian)', 'nativeName': 'français (Swiss)'},
  {'code': 'fr-ch', 'name': 'French (Switzerland)', 'nativeName': 'français (Swiss)'},
  {'code': 'fr', 'name': 'French', 'nativeName': 'français, langue française'},
{'code': 'he', 'name': 'Hebrew (modern)', 'nativeName': 'עברית'},
{'code': 'hi', 'name': 'Hindi', 'nativeName': 'हिन्दी, हिंदी'},
{'code': 'hr', 'name': 'Croatian', 'nativeName': 'hrvatski'},
{'code': 'hu', 'name': 'Hungarian', 'nativeName': 'Magyar'},
{'code': 'id', 'name': 'Indonesian', 'nativeName': 'Bahasa Indonesia'},
{'code': 'it', 'name': 'Italian', 'nativeName': 'Italiano'},
{'code': 'ja', 'name': 'Japanese', 'nativeName': '日本語 (にほんご／にっぽんご)'},
{'code': 'ko', 'name': 'Korean', 'nativeName': '한국어 (韓國語), 조선말 (朝鮮語)'},
{'code': 'lt', 'name': 'Lithuanian', 'nativeName': 'lietuvių kalba'},
{'code': 'lv', 'name': 'Latvian', 'nativeName': 'latviešu valoda'},
{'code': 'ms-my', 'name': 'Malay (Malaysia)', 'nativeName': 'bahasa Melayu, بهاس ملايو‎'},
{'code': 'ms', 'name': 'Malay', 'nativeName': 'bahasa Melayu, بهاس ملايو‎'},
{'code': 'nb', 'name': 'Norwegian Bokmål', 'nativeName': 'Norsk bokmål'},
{'code': 'nl-be', 'name': 'Belgian Dutch'},
{'code': 'nl', 'name': 'Dutch', 'nativeName': 'Nederlands, Vlaams'},
{'code': 'nn', 'name': 'Norwegian Nynorsk', 'nativeName': 'Norsk nynorsk'},
{'code': 'pl', 'name': 'Polish', 'nativeName': 'polski'},
{'code': 'pt-br', 'name': 'Brazilian Portuguese'},
{'code': 'pt', 'name': 'Portuguese', 'nativeName': 'Português'},
{'code': 'ro', 'name': 'Romanian, Moldavian, Moldovan', 'nativeName': 'română'},
{'code': 'ru', 'name': 'Russian', 'nativeName': 'русский язык'},
{'code': 'sk', 'name': 'Slovak', 'nativeName': 'slovenčina'},
{'code': 'sl', 'name': 'Slovene', 'nativeName': 'slovenščina'},
{'code': 'sr-cyrl', 'name': 'Serbian Cyrillic'},
{'code': 'sr', 'name': 'Serbian', 'nativeName': 'српски језик'},
{'code': 'sv', 'name': 'Swedish', 'nativeName': 'svenska'},
{'code': 'th', 'name': 'Thai', 'nativeName': 'ไทย'},
{'code': 'tr', 'name': 'Turkish', 'nativeName': 'Türkçe'},
{'code': 'uk', 'name': 'Ukrainian', 'nativeName': 'українська'},
{'code': 'vi', 'name': 'Vietnamese', 'nativeName': 'Tiếng Việt'},
{'code': 'zh-cn', 'name': 'Mainland China'},
{'code': 'zh-tw', 'name': 'Taiwan'}
]
export default langs



// WEBPACK FOOTER //
// ./src/components/Locale/momentlangs.js